import React from 'react';
import { useNavigate } from 'react-router-dom';
import { allBooks } from '../types/books';
import { AppBook } from '../types/utils';
import './Dashboard.css';

interface DashboardProps {
    book: AppBook;
    selectedBook: string;
    selectedChapter: string;
    availableBooks: string[];
    availableChapters: string[];
    onBookChange: (bookId: string) => void;
    onChapterChange: (chapterId: string) => void;
}

const Dashboard: React.FC<DashboardProps> = (props) => {
  const navigate = useNavigate();
  
  // Debug: Log the books data
  console.log('Dashboard: allBooks loaded:', allBooks.books.map(book => ({ id: book.book_id, title: book.title })));

  const handleTakeQuiz = (bookId: string, chapterId: string) => {
    // Navigate to the quiz with the book ID and chapter ID
    navigate(`/books/${bookId}/quiz/${chapterId}`);
  };

  const handleTakeFinalExam = (bookId: string) => {
    // Navigate to quiz config with book pre-selected and chapter set to "all"
    const url = `/books/${bookId}/quiz/all`;
    console.log(`Dashboard: Navigating to "${url}" for book ID "${bookId}"`);
    navigate(url);
  };

  return (
    <div className="content-container">
      <div className="glass-header">
        <div>
          <h1 className="text-title-xl">🔥 Firefighting Quiz Dashboard</h1>
          <p className="text-body-lg">Browse all available books and their chapters</p>
        </div>
        <div className="dashboard-overview">
          <div className="content-stat">
            <span className="content-stat-number large">{allBooks.books.length}</span>
            <span className="content-stat-label">Books</span>
          </div>
          <div className="content-stat">
            <span className="content-stat-number large">{allBooks.books.reduce((total, book) => total + Object.keys(book.chapters).length, 0)}</span>
            <span className="content-stat-label">Total Chapters</span>
          </div>
        </div>
      </div>

      <div className="content-section">
        <h2 className="text-title-lg">Available Books</h2>
        <div className="content-grid content-grid-large">
          {allBooks.books.map((book) => {
            console.log(`Dashboard: Rendering book "${book.title}" with ID "${book.book_id}"`);
            return (
            <div key={book.book_id} className="content-card">
              <div className="book-card-header">
                <h3 className="text-title-md">{book.title}</h3>
                <span className="text-caption">ID: {book.book_id}</span>
              </div>
              
              <div className="book-card-content">
                <div className="chapter-count">
                  <span className="text-body-md">
                    {Object.keys(book.chapters).length} Chapters
                  </span>
                </div>
                
                <div className="chapter-list">
                  <h4 className="text-title-sm">Chapters:</h4>
                  <ul className="chapter-items">
                    {Object.keys(book.chapters).map((chapterId) => {
                      const chapter = book.chapters[chapterId];
                      const totalQuestions = 
                        (chapter.trueFalseQuestions?.length || 0) + 
                        (chapter.multipleChoiceQuestions?.length || 0);
                      
                      return (
                        <li key={chapterId} className="chapter-item">
                          <div className="chapter-info">
                            <span className="text-body-sm">
                              Chapter {chapterId}: {totalQuestions} questions
                            </span>
                            <button
                              className="btn btn-primary chapter-quiz-btn"
                              onClick={() => handleTakeQuiz(book.book_id, chapterId)}
                              disabled={totalQuestions === 0}
                            >
                              Take Quiz
                            </button>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                
                <div className="book-actions">
                  <button
                    className="btn btn-secondary final-exam-btn"
                    onClick={() => handleTakeFinalExam(book.book_id)}
                  >
                    Take Final Exam
                  </button>
                </div>
              </div>
            </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
